import config from "./config";
import { convertDataToObject } from "./refractCommon/utils/convertDataToObject";
import { miroApiProxy } from "./refractCommon/miro/miroApiProxy";
import { verify } from "crypto";
import { viewportVisibleGet } from "./refractCommon/miro/viewportVisibleGet";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getMiroClientId } from "./refractCommon/utils/useDataStoreMiro";


export const devButtons = config.environment === 'dev' && (
    <div style={{ position: "absolute", bottom: 0, right: 0, opacity: .1 }}>

        <button onClick={async () => {
            console.clear();

            const functions = getFunctions();
            const createPortalSession = httpsCallable(functions, "getCurrentMiroUserV1");
            const result = (await createPortalSession({
                clientId: await getMiroClientId()
            })) as any;
            console.log("result", result.data);




            // const boardData = await miroApiProxy.getBoard((await miro.board.getInfo()).id);
            // console.log("boardData", boardData);

            // const visibleViewport = await viewportVisibleGet();
            // await miro.board.createShape({
            //     x: visibleViewport.x + (visibleViewport.width / 2),
            //     y: visibleViewport.y + (visibleViewport.height / 2),
            //     height: visibleViewport.height,
            //     // height: boardPixelHeight * mult,
            //     width: visibleViewport.width,
            // })


        }}>Test</button>



        &nbsp;&nbsp;App Data:
        <button onClick={async () => {
            // Delete all App Data
            // @ts-ignore
            for (const [key, item] of Object.entries(await miro.board.getAppData())) {
                if (item)
                    await miro.board.setAppData(key, false);
            }

            //Delete an app Data
            //await miro.board.setAppData("palettesTool-3074457346483724539", false)
            console.log("--data cleared--");

        }}>Clear</button>


        <button onClick={async () => {
            // console.clear();
            //Delete an app Data
            //await miro.board.setAppData("palettesTool-3074457346483724539", false)
            // Log all app data
            let dataFound = false;
            // @ts-ignore
            for (const [key, item] of Object.entries(await miro.board.getAppData())) {
                if (item) {
                    console.log(key);
                    console.log(item);
                    console.log(convertDataToObject(item));
                    dataFound = true;
                }
            }
            if (!dataFound)
                console.log("--no data found--");
        }}>Log</button>


    </div>
);

